var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCooking = function SvgCooking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "27px",
    viewBox: "0 0 32 27",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "cotturaGroup 3")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LIbraway_loggato",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ricetta_new",
    transform: "translate(-1303.000000, -630.000000)",
    stroke: "#FFBF3F",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1304.000000, 631.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4791779,24.8418409 L6.31939539,24.8418409 C4.88320396,24.8418409 3.71955206,23.653503 3.71955206,22.187365 L3.71955206,7.72925353 L26.0790213,7.72925353 L26.0790213,22.187365 C26.0790213,23.653503 24.914859,24.8418409 23.4791779,24.8418409 Z",
    id: "Stroke-15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.54747351e-13,
    y1: 12.1902637,
    x2: 3.7196031,
    y2: 12.1902637,
    id: "Stroke-17"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.0789192,
    y1: 12.1902637,
    x2: 29.7985223,
    y2: 12.1902637,
    id: "Stroke-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2272789,1.47082879 C16.2272789,2.28285971 15.5821666,2.94113638 14.7875148,2.94113638 C13.9918423,2.94113638 13.3462197,2.28285971 13.3462197,1.47082879 C13.3462197,0.658276669 13.9918423,0 14.7875148,0 C15.5821666,0 16.2272789,0.658276669 16.2272789,1.47082879 Z",
    id: "Stroke-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76660969,5.15246495 C8.24345297,3.78709121 10.9213835,2.96745301 14.6440488,2.96745301 C18.4907349,2.96745301 21.3299435,3.98303166 23.8532308,5.34840539 C25.0980321,6.02246812 25.4537625,6.55785469 25.7166049,6.98147241 C25.8998291,7.2781428 25.7375303,7.72935777 25.451721,7.72935777 L3.93896169,7.72935777 C3.82718986,7.72935777 3.75063381,7.57964272 3.79095333,7.43889676 C3.93130608,6.95111544 4.18904477,6.02246812 5.76660969,5.15246495 Z",
    id: "Stroke-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.420809,12.4569622 C8.85957603,14.3937445 12.2163035,16.9523195 10.1916512,19.5932442",
    id: "Stroke-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8930601,12.4569622 C13.330296,14.3937445 16.6895753,16.9523195 14.6649231,19.5932442",
    id: "Stroke-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3648008,12.4569622 C17.8030575,14.3937445 21.1602953,16.9523195 19.1371742,19.5932442",
    id: "Stroke-29"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCooking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cooking.8dea4710.svg";
export { ForwardRef as ReactComponent };